import { useContext, useEffect, useMemo } from 'react';
import { vendor as vendorApi } from '../../api';
import { EntityFormProvider, VendorChangeRequestContext } from '../../contexts';
import { useApi, useEntityForm } from '../../hooks';
import { VendorPaymentScheduleEntity } from '../../models';
import { VendorPaymentScheduleSchema } from '../../schemas';
import { ChangeRequestTrigger } from '../../types';
import { EditDrawerChangeRequest } from '../EditDrawerChangeRequest';
import { PaymentScheduleForm } from '../Vendor/Financials/PaymentScheduleForm';
import { ChangeRequestDrawerHeader } from './ChangeRequestDrawerHeader';

export const PaymentScheduleChangeRequest = () => {
  const { changeRequest: vendorChangeRequest, isAfter } = useContext(VendorChangeRequestContext);
  const { data, isLoading } = useApi(vendorApi.getPaymentScheduleChangeRequest, null, vendorChangeRequest.id);
  const { call: update } = useApi(vendorApi.approvedOrRejectPaymentScheduleChangeRequest, {
    successKey: 'common:success.save',
  });
  const entityPlaceholder = useMemo(() => new VendorPaymentScheduleEntity(), []);

  const { handleSubmit, reset, setValues, isSubmitDisabled, form, handleError } =
    useEntityForm<VendorPaymentScheduleEntity>(data?.entity ?? entityPlaceholder, VendorPaymentScheduleSchema(), {
      variant: 'changeRequest',
      readOnly: !isAfter,
    });

  useEffect(() => {
    if (data) {
      if (isAfter) {
        setValues(data?.changeRequest || entityPlaceholder);
      } else {
        reset();
      }
    }
  }, [data, isAfter, setValues, reset, entityPlaceholder, data?.changeRequest]);

  const saveDrawer = (e: VendorPaymentScheduleEntity, trigger: ChangeRequestTrigger) => {
    return update(vendorChangeRequest.id, trigger, e);
  };

  return (
    <EntityFormProvider {...form} isLoading={isLoading || !data}>
      <EditDrawerChangeRequest
        open={true}
        entity={entityPlaceholder}
        handleSubmit={handleSubmit}
        handleError={handleError}
        isSubmitDisabled={isSubmitDisabled}
        reset={reset}
        onSave={saveDrawer}
      >
        <ChangeRequestDrawerHeader />
        <PaymentScheduleForm />
      </EditDrawerChangeRequest>
    </EntityFormProvider>
  );
};
